import React from "react";
import { Link } from "react-router-dom";
import { SectionCard } from "../Ui";

/**
 * Horizontal pipeline counts for manager / admin command center.
 * Each step links to the module that owns that queue.
 */
export default function DashboardPipelineStrip({ pipeline, testId = "dashboard-pipeline" }) {
  if (!pipeline) return null;

  const inward = pipeline.inward || {};
  const outward = pipeline.outward || {};
  const store = pipeline.store || {};

  const lanes = [
    {
      title: "Inward (purchase)",
      steps: [
        { label: "Gate in", count: inward.gate_in, href: "/gate/inward" },
        { label: "Lab", count: inward.lab_pending, href: "/lab" },
        { label: "Ready unload", count: inward.approved, href: "/unloading" },
        { label: "Unloading", count: inward.unloading, href: "/unloading" },
        { label: "Accounts", count: inward.accounts_pending, href: "/accounts" },
      ],
    },
    {
      title: "Outward (sales)",
      steps: [
        { label: "Sales link", count: outward.registered, href: "/sales/link" },
        { label: "Loading", count: outward.weigh_tare, href: "/sales/loading" },
        { label: "Gross weigh", count: (outward.loaded || 0) + (outward.weigh_gross || 0), href: "/weighbridge/outward" },
        { label: "Accounts", count: outward.accounts_pending, href: "/sales/vouchers" },
      ],
    },
    {
      title: "Store (general PO)",
      steps: [
        { label: "Awaiting GRN", count: store.awaiting_grn, href: "/store/grn" },
        { label: "Tare weigh", count: store.tare_pending, href: "/weighbridge" },
      ],
    },
  ];

  return (
    <SectionCard title="Pipeline snapshot" testId={testId}>
      <div className="space-y-4">
        {lanes.map((lane) => (
          <div key={lane.title}>
            <p className="text-[10px] uppercase tracking-widest text-muted-foreground font-medium mb-2">
              {lane.title}
            </p>
            <div className="flex flex-wrap gap-2">
              {lane.steps.map((step) => (
                <Link
                  key={`${lane.title}-${step.label}`}
                  to={step.href}
                  className="rounded-lg border border-border bg-card px-3 py-2 min-w-[5.5rem] hover:bg-muted/40 transition-colors"
                  data-testid={`pipeline-${step.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="text-lg font-serif tabular text-foreground leading-none">{step.count ?? 0}</div>
                  <div className="text-[10px] text-muted-foreground mt-1">{step.label}</div>
                </Link>
              ))}
            </div>
          </div>
        ))}
        <div className="flex flex-wrap gap-3 pt-1 border-t border-border/60">
          <Link
            to="/accounts/tally-mapping"
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            Tally not synced: <span className="font-semibold text-foreground tabular">{pipeline.tally_pending ?? 0}</span>
          </Link>
          <Link to="/gate" className="text-xs text-muted-foreground hover:text-foreground">
            In yard: <span className="font-semibold text-foreground tabular">{pipeline.gate_open ?? 0}</span>
          </Link>
        </div>
      </div>
    </SectionCard>
  );
}
